export function VisaIcon({ size = 38 }) {
  return (
    <svg width={38} height={24} viewBox="0 0 40 24" fill="none">
      <rect width="40" height="24" rx="3" fill="#1A1F71" />
      <text x="20" y="15.5" textAnchor="middle" fill="#fff" fontFamily="Arial" fontWeight="bold" fontStyle="italic" fontSize="11">VISA</text>
    </svg>
  );
}

export function MastercardIcon({ size = 38 }) {
  return (
    <svg width={38} height={24} viewBox="0 0 40 24" fill="none">
      <rect width="40" height="24" rx="3" fill="#252525" />
      <circle cx="16" cy="12" r="7" fill="#EB001B" />
      <circle cx="24" cy="12" r="7" fill="#F79E1B" />
      <path d="M20 6.8a7 7 0 010 10.4 7 7 0 000-10.4z" fill="#FF5F00" />
    </svg>
  );
}

export function AmexIcon({ size = 38 }) {
  return (
    <svg width={38} height={24} viewBox="0 0 40 24" fill="none">
      <rect width="40" height="24" rx="3" fill="#006FCF" />
      <text x="20" y="15" textAnchor="middle" fill="#fff" fontFamily="Arial" fontWeight="bold" fontSize="8">AMEX</text>
    </svg>
  );
}

export function PaypalIcon({ size = 38 }) {
  return (
    <svg width={38} height={24} viewBox="0 0 40 24" fill="none">
      <rect width="40" height="24" rx="3" fill="#FFF" stroke="#E5E5E5" strokeWidth="0.5" />
      <text x="10" y="15.5" fill="#253B80" fontFamily="Arial" fontWeight="bold" fontStyle="italic" fontSize="9">Pay</text>
      <text x="24.5" y="15.5" fill="#179BD7" fontFamily="Arial" fontWeight="bold" fontStyle="italic" fontSize="9">Pal</text>
    </svg>
  );
}

export function ApplePayIcon({ size = 38 }) {
  return (
    <svg width={38} height={24} viewBox="0 0 40 24" fill="none">
      <rect width="40" height="24" rx="3" fill="#000" />
      <text x="20" y="15" textAnchor="middle" fill="#fff" fontFamily="Arial" fontWeight="500" fontSize="9"> Pay</text>
    </svg>
  );
}

export function GooglePayIcon({ size = 38 }) {
  return (
    <svg width={38} height={24} viewBox="0 0 40 24" fill="none">
      <rect width="40" height="24" rx="3" fill="#FFF" stroke="#E5E5E5" strokeWidth="0.5" />
      <text x="8" y="16" fill="#4285F4" fontFamily="Arial" fontWeight="bold" fontSize="10">G</text>
      <text x="17" y="15.5" fill="#5F6368" fontFamily="Arial" fontWeight="500" fontSize="8">Pay</text>
    </svg>
  );
}

export function SecureBadgeIcon({ size = 38 }) {
  return (
    <svg width={38} height={24} viewBox="0 0 40 24" fill="none">
      <rect width="40" height="24" rx="3" fill="#f0f0f0" />
      <path d="M20 5l7 3v5c0 4-3 7-7 9-4-2-7-5-7-9V8l7-3z" fill="#4CAF50" stroke="none" />
      <path d="M17.5 12l2 2 4-4" stroke="#fff" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default function PaymentIcons({ size = 38, className = '', showLabel = true }) {
  return (
    <div className={`text-center ${className}`} data-testid="payment-icons">
      {showLabel && (
        <p className="font-sans text-[10px] uppercase tracking-[0.15em] mb-2" style={{ color: '#999' }}>Guaranteed Safe Checkout</p>
      )}
      <div className="flex items-center justify-center gap-2 flex-wrap">
        <VisaIcon />
        <MastercardIcon />
        <AmexIcon />
        <PaypalIcon />
        <ApplePayIcon />
        <GooglePayIcon />
        <SecureBadgeIcon />
      </div>
    </div>
  );
}
